import { memo, splitProps } from '../helpers.js';
import { createRecipe, mergeRecipes } from './create-recipe.js';

const aromaFilterTriggerFn = /* @__PURE__ */ createRecipe('aroma-filter', {
  "active": false
}, [])

const aromaFilterTriggerVariantMap = {
  "active": [
    "true",
    "false"
  ]
}

const aromaFilterTriggerVariantKeys = Object.keys(aromaFilterTriggerVariantMap)

export const aromaFilterTrigger = /* @__PURE__ */ Object.assign(memo(aromaFilterTriggerFn.recipeFn), {
  __recipe__: true,
  __name__: 'aromaFilterTrigger',
  __getCompoundVariantCss__: aromaFilterTriggerFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: aromaFilterTriggerVariantKeys,
  variantMap: aromaFilterTriggerVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, aromaFilterTriggerVariantKeys)
  },
  getVariantProps: aromaFilterTriggerFn.getVariantProps,
})